export default __webpack_public_path__ + "static/media/gold.48e8248e.svg";